import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateUbsValidateAssetOperationMutationVariables = Types.Exact<{
  input: Types.CreateUbsValidateAssetOperationInput;
}>;


export type CreateUbsValidateAssetOperationMutation = { __typename?: 'Mutation', createUbsValidateAssetOperation?: { __typename?: 'FireflyOperationPayload', fireflyOperation?: { __typename?: 'FireflyOperation', id?: string | null } | null } | null };


export const CreateUbsValidateAssetOperation = /*#__PURE__*/ gql`
    mutation CreateUbsValidateAssetOperation($input: CreateUbsValidateAssetOperationInput!) {
  createUbsValidateAssetOperation(input: $input) {
    fireflyOperation {
      id
    }
  }
}
    ` as unknown as DocumentNode<CreateUbsValidateAssetOperationMutation, CreateUbsValidateAssetOperationMutationVariables>;

          

          export const useCreateUbsValidateAssetOperationMutation = (options?:MutationHookOptions<CreateUbsValidateAssetOperationMutation, CreateUbsValidateAssetOperationMutationVariables>) => useMutation(CreateUbsValidateAssetOperation, options);
          

          export type CreateUbsValidateAssetOperationMutationOptions = MutationHookOptions<CreateUbsValidateAssetOperationMutation, CreateUbsValidateAssetOperationMutationVariables>;

          

          export type CreateUbsValidateAssetOperationMutationResult = ReturnType<typeof useCreateUbsValidateAssetOperationMutation>[1];

          
